export const Tab = ({ tabId, isActive, count, handleTabClick }) => (
    <li className="nav-item" role="presentation">
      <button
        className={`nav-link mx-2 ${isActive ? 'active' : ''}`}
        id={`${tabId}-tab`}
        data-toggle="tab"
        data-target={`#${tabId}`}
        type="button"
        role="tab"
        aria-controls={tabId}
        aria-selected={isActive}
        onClick={() => handleTabClick(tabId)}
      >
       {count} {tabId.toUpperCase()}
      </button>
    </li>
  );

  export const TabContent = ({ tabId, isActive, children }) => (
    <div
      className={`tab-pane fade ${isActive ? 'show active' : ''}`}
      id={tabId}
      role="tabpanel"
      aria-labelledby={`${tabId}-tab`}
    >
      {children}
    </div>
  );